import {
  PreferenceGroup,
  PreferenceKeyImpl,
} from "@services/userPreferences/types";
import { GlobalPreferencesContextData } from ".";

export const DEFAULT_PAGE_SIZE = 50;
export const MIN_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;

export const preferencesDefaultContextValue = {
  loaded: false,
  errored: false,
  [PreferenceGroup.LIST_VIEW]: {
    [PreferenceKeyImpl.global]: {
      pageSize: DEFAULT_PAGE_SIZE,
      bulkImportPageSize: MIN_PAGE_SIZE,
    },
  },
};
export type PreferenceCreationType<
  T extends keyof GlobalPreferencesContextData = PreferenceGroup.LIST_VIEW
> = {
  groupName: T;
  key: keyof GlobalPreferencesContextData[T];
};
export type PreferenceToLoadType<
  T extends keyof GlobalPreferencesContextData = PreferenceGroup.LIST_VIEW
> = {
  groupName: T;
  keys: Array<keyof GlobalPreferencesContextData[T]>;
};
export const preferencesToLoad: PreferenceToLoadType[] = [
  {
    groupName: PreferenceGroup.LIST_VIEW,
    keys: [PreferenceKeyImpl.global],
  },
];
